import { styled } from '@mui/material';
import { lightPalette, up } from '../../../../../theme';

export const classes = {
  root: 'root',
  CardComponent: 'CardComponent',
  errorCardComponent: 'errorCardComponent',
  CloseAction: 'CloseAction',
  CardHeader: 'CardHeader',
  CardContent: 'CardContent',
  AvatarBox: 'AvatarBox',
  noChangesMessage: 'noChangesMessage',
  loaderBox: 'loaderBox',
  GridBox: 'GridBox',
  GridItems: 'GridItems',
  GridItemsTypography: 'GridItemsTypography',
  GridItemTextfield: 'GridItemTextfield',
  Box: 'Box',
  CancelButton: 'CancelButton',
  uploadAvatarButton: 'uploadAvatarButton',
  UpdateButton: 'UpdateButton',
  avatar: 'avatar',
  AdminProfilePicture: 'AdminProfilePicture',
  AvatarButtonContainer: 'AvatarButtonContainer',
  header: 'header',
  noteTextBox: 'noteTextBox',
  CardComponentOrgSubscription: 'CardComponentOrgSubscription',
  BoxUpdateStyle: 'BoxUpdateStyle',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.CardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '300px',
    },
    [up('sm')]: {
      width: '470px',
      height: '385px',
    },
    [up('md')]: {
      width: '510px',
      height: '430px',
    },
    [up('lg')]: {
      width: '640px',
      height: '475px',
    },
    [up('xl')]: {
      width: '710px',
      height: '575px',
    },
    [up('xxl')]: {
      width: '977px',
      height: '680px',
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '390px',
      height: '370px',
    },
    [up('sm')]: {
      width: '490px',
      height: '430px',
    },
    [up('md')]: {
      width: '510px',
      height: '470px',
    },
    [up('lg')]: {
      width: '640px',
      height: '520px',
    },
    [up('xl')]: {
      width: '710px',
      height: '620px',
    },
    [up('xxl')]: {
      width: '977px',
      height: '730px',
    },
  },
  [`& .${classes.AvatarBox}`]: {
    display: 'flex',
    marginTop: '20px',
  },
  [`& .${classes.avatar}`]: {
    backgroundColor: theme.palette.primary.main,
    marginLeft: '0vw',
    [up('xs')]: {
      height: '40px',
      width: '40px',
      marginTop: '0.6vh',
    },
    [up('md')]: {
      height: '40px',
      width: '40px',
      marginTop: '0.76vh',
    },
    [up('lg')]: {
      height: '45px',
      width: '45px',
      marginTop: '1.76vh',
    },
  },
  [`& .${classes.AvatarButtonContainer}`]: {
    // marginTop: '2.777vh',
    marginTop: '1.76vh',
    // marginLeft: '1.770vw',
    marginLeft: '0vw',
    [up('xs')]: {
      height: '24px',
    },
    [up('sm')]: {
      height: '26px',
    },
    [up('md')]: {
      height: '28px',
    },
    [up('lg')]: {
      height: '50px',
    },
    [up('xl')]: {
      height: '58px',
    },
    [up('xxl')]: {
      height: '60px',
    },
  },
  [`& .${classes.CloseAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.CardHeader}`]: {
    width: '100%',
    color: lightPalette.darkPurple.main,
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.CardContent}`]: {
    width: '100%',
    // overflow: 'auto',
    // '&::-webkit-scrollbar': {
    //   width: '6px',
    //   borderRadius: '8px',
    // },
    // '&::-webkit-scrollbar-track': {
    //   background: `${lightPalette.lynxWhite.main}`,
    //   borderRadius: '8px',
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   background: `${lightPalette.secondaryBlack.lighter}`,
    //   borderRadius: '8px',
    // },
    [up('xs')]: {
      padding: '6px',
      // height: '240px',
    },
    [up('sm')]: {
      padding: '9px',
      // height: '390px',
    },
    [up('md')]: {
      padding: '14px',
      // height: '415px',
    },
    [up('lg')]: {
      padding: '18px',
      // height: '415px',
    },
    [up('xl')]: {
      padding: '22px',
      // height: '520px',
    },
    [up('xxl')]: {
      padding: '30px',
      // height: '666px',
    },
  },
  [`& .${classes.GridBox}`]: {
    [up('xs')]: {
      marginBottom: '7px',
    },
    [up('sm')]: {
      marginBottom: '9px',
    },
    [up('md')]: {
      marginBottom: '14px',
    },
    [up('lg')]: {
      marginBottom: '18px',
    },
    [up('xl')]: {
      marginBottom: '22px',
    },
    [up('xxl')]: {
      marginBottom: '26px',
    },
  },
  [`& .${classes.noChangesMessage}`]: {
    width: '100%',
    textAlign: 'center',
    padding: '5px 0',
    color: theme.palette.colorRed.main,
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '60vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
  [`& .${classes.GridItems}`]: {
    height: '100%',
    width: '100%',
  },
  [`& .${classes.header}`]: {
    display: 'flex',
  },
  [`& .${classes.GridItemsTypography}`]: {
    color: lightPalette.darkPurple.main,
    [up('xs')]: {
      paddingBottom: '3px',
    },
    [up('sm')]: {
      paddingBottom: '4px',
    },
    [up('md')]: {
      paddingBottom: '5px',
    },
    [up('lg')]: {
      paddingBottom: '6px',
    },
    [up('xl')]: {
      paddingBottom: '8px',
    },
    [up('xxl')]: {
      paddingBottom: '10px',
    },
  },
  [`& .${classes.GridItemTextfield}`]: {
    borderColor: lightPalette.darkPurple.lighter,
    borderRadius: '5px',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '20px',
      },
      [up('lg')]: {
        height: '25px',
      },
      [up('xl')]: {
        height: '30px',
      },
      [up('xxl')]: {
        height: '45px',
      },
    },
  },
  [`& .${classes.Box}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '45px',
    },
    [up('sm')]: {
      height: '90px',
    },
    [up('md')]: {
      height: '90px',
    },
    [up('lg')]: {
      height: '67px',
    },
    [up('xl')]: {
      height: '92px',
    },
    [up('xxl')]: {
      height: '130px',
    },
  },
  [`& .${classes.BoxUpdateStyle}`]: {
    [up('xs')]: {
      height: '45px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '70px',
    },
    [up('xl')]: {
      height: '92px',
    },
    [up('xxl')]: {
      height: '52px',
    },
  },
  [`& .${classes.noteTextBox}`]: {
    [up('xs')]: {
      height: '65px',
    },
    [up('sm')]: {
      height: '50px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '60px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.CardComponentOrgSubscription}`]: {
    height: '100%',
  },
  [`& .${classes.CancelButton}`]: {
    backgroundColor: lightPalette.paperWhite.main,
    color: lightPalette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.uploadAvatarButton}`]: {
    backgroundColor: lightPalette.paperWhite.main,
    marginLeft: '1.72vw',
    marginTop: '0vh',
    color: lightPalette.lunarBase.main,
    [up('xs')]: {
      width: '80px',
      height: '30px',
    },
    [up('sm')]: {
      width: '99px',
      height: '45px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
    },
  },
  [`& .${classes.UpdateButton}`]: {
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
}));
